import React from "react";
import UseContext from "hooks/useContext";
import { TeamIcon } from "assets/icons";

const PerimeterEmptyState = () => {
    const { language } = UseContext();

    return (
        <div className="flex flex-col items-center gap-2 rounded-xl border border-dashed border-gray-200 px-6 py-12 text-center">
            <div
                aria-hidden="true"
                className="mb-1 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100"
            >
                <TeamIcon wh={18} color="#374151" />
            </div>
            <h3 className="text-base font-medium text-gray-900">
                {language.getValue("perimeters.empty.title")}
            </h3>
            <p className="max-w-md text-sm text-gray-500">
                {language.getValue("perimeters.empty.description")}
            </p>
        </div>
    );
};

export default PerimeterEmptyState;
